var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[(_vm.label)?_c('label',_vm._b({},'label',_vm.labelProps,false),[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),_c('v-date-picker',{attrs:{"value":_vm.value,"attributes":[
            {
                key: 'today',
                highlight: {
                    fillMode: 'light',
                    contentClass: 'bg-light'
                },
                dates: new Date(),
            } ],"input-props":{
            class: 'form-control form-control-' + _vm.size,
            placeholder: _vm.placeholder,
        },"popover":{ visibility: 'click', }},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }